import { usePaymentMethodAction } from '../hooks/useCheckoutAction'
import { ActionProgress, Icon } from '@ztechapps/webui.util'
import { OrderCheckoutActivePanelEnum } from '@ztechapps/order.common'
import React from 'react'
import { useCheckoutContext } from '../index'

export const PaymentMethodActionProgressStep = () => {
  const [onClickPaymentMethod] = usePaymentMethodAction()
  const checkoutContext = useCheckoutContext()
  const [shippingOptions] = checkoutContext.shippingOptions
  return (
    <ActionProgress.Step
      stepKey={OrderCheckoutActivePanelEnum.paymentMethod}
      canStep={!!shippingOptions?.carrierRate?._id}
      onClick={onClickPaymentMethod}
    >
      <Icon name="circle-dollar-to-slot" /> Payment
    </ActionProgress.Step>
  )
}
